import { defineComponent as D, computed as k, openBlock as n, createBlock as O, resolveDynamicComponent as w, withCtx as C, createElementBlock as s, createElementVNode as t, toDisplayString as o, createCommentVNode as u, Fragment as i, renderList as m, renderSlot as f, mergeProps as c, unref as v } from "vue";
import { useCalendarDays as E } from "./composables/useCalendarDays.js";
import A from "dayjs";
import { CALENDAR_VIEW_MODE as p } from "./enum.js";
const B = {
  key: 0,
  class: "v-calendar-grid-header"
}, b = { class: "v-calendar-grid-body" }, N = { class: "v-calendar-button" }, H = {
  key: 1,
  class: "v-calendar-month-select"
}, S = /* @__PURE__ */ D({
  __name: "v-calendar-grid",
  props: {
    viewDate: { default: () => A() },
    disableHeader: { type: Boolean },
    mode: { default: p.MONTH },
    is: {}
  },
  setup(h) {
    const l = h, g = Array.from({ length: 12 }, (e, d) => d), r = k(() => E(l.viewDate));
    function _(e) {
      return e.isAfter(l.viewDate.endOf("month")) || e.isBefore(l.viewDate.startOf("month"));
    }
    return (e, d) => (n(), O(w(e.is ?? "div"), { class: "v-calendar-grid-root" }, {
      default: C(() => [
        e.disableHeader ? u("", !0) : (n(), s("header", B, [
          t("strong", null, o(r.value[0].format("dd")), 1),
          t("strong", null, o(r.value[1].format("dd")), 1),
          t("strong", null, o(r.value[2].format("dd")), 1),
          t("strong", null, o(r.value[3].format("dd")), 1),
          t("strong", null, o(r.value[4].format("dd")), 1),
          t("strong", null, o(r.value[5].format("dd")), 1),
          t("strong", null, o(r.value[6].format("dd")), 1)
        ])),
        t("main", b, [
          (n(!0), s(i, null, m(r.value, (a, y) => f(e.$slots, "day", c({
            key: y,
            ref_for: !0
          }, {
            value: a,
            isOutside: _(a)
          }), () => [
            t("span", N, o(a.date()), 1)
          ])), 128))
        ]),
        e.mode == v(p).YEAR ? (n(), s("div", H, [
          (n(!0), s(i, null, m(v(g), (a) => f(e.$slots, "month", c({
            key: a,
            ref_for: !0
          }, {
            value: e.viewDate.set("month", a).startOf("month")
          }))), 128))
        ])) : u("", !0)
      ]),
      _: 3
    }));
  }
});
export {
  S as default
};
